import React from "react";
import { formatUkNumber, getFinancialDateRange } from "../utils";
const CoachingInsights = ({ coachingInsight,formData }) => {
    const {
        ratingData = {},
        messagesData = {},
        callData = {}
    } = coachingInsight || {};

    const date = getFinancialDateRange(formData.financialYearRange);
    const weekly = `${formData._fromDate} - ${formData._toDate}`;
    return (
        <div className="mt-8  p-4 rounded  is-drop-when-no-space" style={{ background: '#f1f4f9' }}>
            <h3 className="text-center mb-4">Overall Coaching Insights</h3>
            <p className="text-center">
                Date Range : {weekly}<br/>
                Yearly : {date}
            </p>
           
            <div className="row g-4">
                <div className="col-md-4">

                    <div className="text-center">
                        <div className="d-flex justify-content-center align-items-center mb-2">
                            {/* <div className="display-6 pt-4">{insight.icon}</div> */}
                            <h5 className="card-title mt-6 ms-1">Call Insights</h5>
                        </div>

                        <div className="bg-white rounded">
                            <table className="table table_wrap custom-header2">
                                <thead style={{ backgroundColor: "#d4edda" /* Light green */ }}>
                                    <tr>
                                        <th className="break-line">Period</th>
                                        <th className="break-line">Total <br/> Calls
                                        <br/><span style={{color:'transparent'}}>.</span>

                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr >
                                        <td className="break-line_td">Date Range</td>
                                        <td>{formatUkNumber(callData.last_full_week_conversations || 0)}</td>

                                    </tr>
                                    <tr >
                                        <td className="break-line_td">Yearly</td>
                                        <td>{formatUkNumber(callData.total_conversations || 0)}</td>

                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* </div> */}
                </div>

                <div className="col-md-4">

                    <div className="text-center">
                        <div className="d-flex justify-content-center align-items-center mb-2">
                            {/* <div className="display-6 pt-4">{insight.icon}</div> */}
                            <h5 className="card-title mt-6 ms-1">Messaging Insights</h5>
                        </div>

                        <div className="bg-white rounded">
                            <table className="table table_wrap custom-header2">
                                <thead style={{ backgroundColor: "#d4edda" /* Light green */ }}>
                                    <tr>
                                        <th className="break-line">Period</th>
                                        <th className="break-line">Messages Sent by Coach</th>
                                        <th className="break-line">Messages Sent by Patient</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr >
                                        <td className="break-line_td">Date Range</td>
                                        <td>{formatUkNumber(messagesData.latest_week_coach_messages || 0)}</td>
                                        <td>{formatUkNumber(messagesData.latest_week_user_messages || 0)}</td>
                                    </tr>
                                    <tr >
                                        <td className="break-line_td">Yearly</td>
                                        <td>{formatUkNumber(messagesData.total_coach_messages || 0)}</td>
                                        <td>{formatUkNumber(messagesData.total_user_messages || 0)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* </div> */}
                </div>

                <div className="col-md-4">

                    <div className="text-center">
                        <div className="d-flex justify-content-center align-items-center mb-2">
                            {/* <div className="display-6 pt-4">{insight.icon}</div> */}
                            <h5 className="card-title mt-6 ms-1">Rating Insights</h5>
                        </div>

                        <div className="bg-white rounded">
                            <table className="table table_wrap custom-header2">
                                <thead style={{ backgroundColor: "#d4edda" /* Light green */ }}>
                                    <tr>
                                        <th className="break-line">Period</th>
                                        <th className="break-line">Total Ratings Receive</th>
                                        <th className="break-line">Average Rating</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr >
                                        <td className="break-line_td">Date Range</td>
                                        <td>{formatUkNumber(ratingData.weekly_rating_count || 0)}</td>
                                        <td>{formatUkNumber(ratingData.weekly_avg_rating || 0)}</td>
                                    </tr>
                                    <tr >
                                        <td className="break-line_td">Yearly</td>
                                        <td>{formatUkNumber(ratingData.overall_rating_count || 0)}</td>
                                        <td>{formatUkNumber(ratingData.overall_avg_rating || 0)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* </div> */}
                </div>

            </div>
        </div>
    );
};

export default CoachingInsights;
